<div class="faq-section border-round-lg p-4 mb-5 surface-card shadow-2">
  <div class="flex align-items-center justify-content-between mb-4">
    <h2 class="text-2xl font-medium m-0">Frequently Asked Questions</h2>
    <button
      *ngIf="authService.doesHaveRole(['SYSADMIN'])"
      pButton
      icon="pi pi-plus"
      label="Add FAQ"
      [routerLink]="['/app/faq/add-faq']"
      class="p-button-outlined"
    ></button>
  </div>

  <p-accordion styleClass="faq-accordion">
    <p-accordionTab *ngFor="let faq of faqs" [header]="faq.question">
      <div class="p-2">
        <p class="line-height-3">{{ faq?.answer }}</p>
      </div>
      <ng-template pTemplate="icons">
        <button
          *ngIf="authService.doesHaveRole(['SYSADMIN'])"
          pButton
          class="p-button-text p-button-rounded p-button-plain"
          icon="pi pi-cog"
          (click)="$event.stopPropagation(); menu.toggle($event)"
        ></button>
        <p-menu #menu [model]="faq.menuItems" [popup]="true"></p-menu>
      </ng-template>
    </p-accordionTab>
  </p-accordion>
</div>
